import { render, staticRenderFns } from "./index-personal.vue?vue&type=template&id=5a47f3e6&"
import script from "./index-personal.vue?vue&type=script&lang=js&"
export * from "./index-personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports